export const QUERY_PAGE_SIZE = 100;
